import { render, staticRenderFns } from "./DownLogs.vue?vue&type=template&id=523a7022&scoped=true&"
import script from "./DownLogs.vue?vue&type=script&lang=js&"
export * from "./DownLogs.vue?vue&type=script&lang=js&"
import style0 from "./DownLogs.vue?vue&type=style&index=0&id=523a7022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a7022",
  null
  
)

export default component.exports